import { api } from '@services';

import qs from 'query-string';

interface IRequest {
  studioId: string;
  search?: string;
  assigneeId?: string;
}

export interface IGetTasksCount {
  todo: number;
  inprogress: number;
  done: number;
  all: number;
}

const getTasksCount = async ({
  studioId,
  search,
  assigneeId,
}: IRequest): Promise<IGetTasksCount> => {
  const query = {
    q: search,
    assigneeId,
  };

  const queryString = qs.stringify(query);

  const { data: count } = await api.get<IGetTasksCount>(
    `/studios/${studioId}/tasks/count?${queryString}`,
  );

  return count;
};

export { getTasksCount };
